<template>
    <img
        v-if="!white"
        v-bind:src="'/musicologie-wordmark-300.webp'"
        style="max-width: 300px"
    />
    <img
        v-else
        v-bind:src="'/Musicologie-White-Wordmark.png'"
        style="max-width: 300px"
    />
</template>

<script>
export default {
    props: {
        white: {
            type: Boolean,
            default: false
        }
    }
};
</script>
